import { render, staticRenderFns } from "./stock-detail.vue?vue&type=template&id=cc878a2a&"
import script from "./stock-detail.vue?vue&type=script&lang=js&"
export * from "./stock-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports